module.exports = __webpack_public_path__ + "static/media/Trust-Badge-6.acfc0583.png";